import type { FileStorageConfiguration } from "../types/FileStorageConfiguration"

export const DefaultBackend: FileStorageConfiguration = {
  db: "Files",
  enum: "Browser",
}
